var map = {
	"./1024.webp": 912,
	"./128.webp": 448,
	"./16.webp": 132,
	"./2.webp": 935,
	"./2048.webp": 501,
	"./256.webp": 712,
	"./32.webp": 486,
	"./4.webp": 541,
	"./4096.webp": 416,
	"./512.webp": 65,
	"./64.webp": 801,
	"./8.webp": 177,
	"./8192.webp": 311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 620;